<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useAuthStore } from '@/stores/authStore'
import AppHeader from './AppHeader.vue'
import AppSidebar from './AppSidebar.vue'
import AppFooter from './AppFooter.vue'
import DevTierToggle from '@/components/DevTierToggle.vue'

const route = useRoute()
const auth = useAuthStore()

const showSidebar = computed(() => auth.isAuthenticated && !route.meta?.public)
</script>

<template>
  <div class="min-h-screen bg-slate-50 text-slate-900 dark:bg-slate-950 dark:text-slate-100">
    <AppHeader />
    <div class="flex">
      <AppSidebar v-if="showSidebar" />
      <main class="flex-1 min-h-[calc(100vh-4rem)]">
        <slot />
      </main>
    </div>
    <AppFooter v-if="!showSidebar" />
    <DevTierToggle />
  </div>
</template>
